var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactAccept(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "13364145-5FC3-4A1A-B8A3-A1156F4A0756") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Styleguide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-828.000000, -3215.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(127.000000, 3160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/user_accept",
    transform: "translate(701.000000, 55.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,13 C15.8769668,13 17.4663414,13.7725565 18.5367805,15.0001315 L17.0743968,14.9995934 C16.2556546,14.3753899 15.2090367,14 14,14 L10,14 C7.5,14 5.11818189,16.1223067 5.00461951,18.7831104 L5,19 L15,19 L15,20 L4,20 L4,19 C4,15.6862915 6.5,13 10,13 L14,13 Z M12,4 C14.209139,4 16,5.790861 16,8 C16,10.209139 14.209139,12 12,12 C9.790861,12 8,10.209139 8,8 C8,5.790861 9.790861,4 12,4 Z M12,5 C10.3431458,5 9,6.34314575 9,8 C9,9.65685425 10.3431458,11 12,11 C13.6568542,11 15,9.65685425 15,8 C15,6.34314575 13.6568542,5 12,5 Z",
    id: "Combined-Shape",
    fill: "#545D61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "",
    id: "Combined-Shape",
    stroke: "#11D364",
    fill: "#D8D8D8"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactAccept);
export default __webpack_public_path__ + "static/media/contact-accept.27b03ac5.svg";
export { ForwardRef as ReactComponent };